import config from "../config";

const fetchCountries = async (
  limit = 15,
  skip = 0,
  search = "",
  field = ""
) => {
  let query = `$limit=${limit}&$skip=${skip}`;

  if (search?.trim() && field) {
    query += `&${field}[$search]=${search.trim()}`;
  }

  const url = `${config.coreUrl}/country?${query}`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error("Failed to fetch countries");
  }

  const json = await response.json();

  return {
    total: json.total,
    skip: json.skip,
    limit: json.limit,
    data: json.data,
  };
};

export default fetchCountries;
